import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { catchError, from, map, of, switchMap } from 'rxjs';
import { DealerFeature } from '..';
import { DealerApiService } from '../../api/dealer-api.service';
import { actions } from './models.actions';

@Injectable()
export class ModelsEffects {
    actions$ = inject(Actions);
    dealerApi = inject(DealerApiService);
    store = inject(Store);

    loadModelList$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.loadModelList),
            concatLatestFrom(() => this.store.select(DealerFeature.state.selectDealerSlug)),
            switchMap(([, dealerSlug]) =>
                from(this.dealerApi.getModelList(dealerSlug)).pipe(
                    map((modelList) => actions.loadModelListSuccess({ modelList })),
                    catchError((error) => of(actions.loadModelListFailure({ error }))),
                ),
            ),
        );
    });

    loadModelDetail$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.loadModelDetail),
            concatLatestFrom(() => this.store.select(DealerFeature.state.selectDealerSlug)),
            switchMap(([{ slug }, dealerSlug]) =>
                from(this.dealerApi.getModelDetail(dealerSlug, slug)).pipe(
                    map((model) => actions.loadModelDetailSuccess({ model })),
                    catchError((error) => of(actions.loadModelDetailFailure({ error }))),
                ),
            ),
        );
    });
}
